/* @flow */
import * as React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'common/components/core/router';

import { getPasswordExpiryNotificationDoItLaterAt } from 'common/redux/selectors/appPreferences';
import { passwordExpiryNotificationVisibleSelector } from 'common/redux/selectors/password';
import {
    clientIdSelector,
    personnelIdSelector,
    sessionSelector
} from 'common/redux/selectors/sessionSelector';
import { PasswordExpiryNotificationActions } from 'common/redux/actions/password';
import { Session } from 'common/models/internal/Session';
import TimeUtils from 'common/utils/TimeUtils';

import { connect } from 'react-redux';

type Props = {
    doItLaterAt: ?string,
    isVisible: ?boolean,
    showNotification: (clientId: string, personnelId: string) => void,
    clientId: string,
    personnelId: string,
    session: ?Session
};

class PasswordExpiryNotificationTrigger extends React.Component<Props> {
    componentDidMount() {
        this._checkAndShowNotification();
    }

    componentWillUmount() {
        clearTimeout(this._timeoutId);
    }

    _DELAY = 3000;
    _timeoutId: ?TimeoutID = null;

    _isNotificationDismissedToday() {
        const { doItLaterAt } = this.props;
        return doItLaterAt
            ? TimeUtils.isSame(TimeUtils.now(), doItLaterAt, 'day')
            : false;
    }

    _isNotificationAlreadyTriggered() {
        return typeof this.props.isVisible === 'boolean';
    }

    _checkAndShowNotification() {
        const { props } = this;
        const { session } = props;
        if (!session) {
            return;
        }

        if (
            (session.isPasswordExpiringInNext7Days() ||
                session.isPasswordExpired()) &&
            !this._isNotificationAlreadyTriggered() &&
            // Don't show notification if user `doItLater` today
            !this._isNotificationDismissedToday()
        ) {
            // Show notification after some time
            this._timeoutId = setTimeout(() => {
                props.showNotification(props.clientId, props.personnelId);
            }, this._DELAY);
        }
    }

    render() {
        return null;
    }
}

export default compose(
    connect(
        (state, props) => {
            return {
                doItLaterAt: getPasswordExpiryNotificationDoItLaterAt(
                    state,
                    props
                ),
                isVisible: passwordExpiryNotificationVisibleSelector(state),
                clientId: clientIdSelector(state, props),
                personnelId: personnelIdSelector(state),
                session: sessionSelector(state)
            };
        },
        {
            showNotification: PasswordExpiryNotificationActions.show
        }
    ),
    withRouter
)(PasswordExpiryNotificationTrigger);
